import { ShoppingCart } from '@/interfaces/checkout/shopping-cart';
import request from '@components/common/services/request';

const url = 'v1/checkout/finish';
let response: ShoppingCart;
export async function get(requestData: {Token: string, PaymentStatus: string}): Promise<ShoppingCart> {
	try {
		response = await request<ShoppingCart>({ method: 'post', url, data: requestData }, 'checkout-finish', 1, true);
		return getShoppingCart(response);
	} catch (error) {
		console.error('Checkout Finish error: ', {
			'Finish Request Data': JSON.stringify(requestData),
			'Finish Request Response': JSON.stringify(response),
			'Finish Request Error': error instanceof Error ? error.message : JSON.stringify(error),
		});
		throw error;
	}
}

function getShoppingCart(resp: ShoppingCart | null) {
	if (!resp || Object.keys(resp).length === 0) {
		throw new Error('Shopping Cart response is empty');
	}
	if (resp.Errors && resp.Errors[0]?.Message === 'Expired token!') {
		throw new Error('Expired Token');
	}
	if (resp.Errors && resp.Errors.length > 0) {
		throw new Error(resp.Errors[0].Message);
	}
	return resp;
}
